import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ad72817"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = { class: "container-fluid py-3 page-main-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col text-center page-main-title" }
const _hoisted_5 = { class: "white-text" }
const _hoisted_6 = { class: "col-md-9 col-lg-10 px-md-4" }
const _hoisted_7 = { class: "container py-3" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6 py-3" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 text-center text-lg-start py-3" }
const _hoisted_12 = { class: "hc1 bold" }
const _hoisted_13 = { class: "row mx-3" }
const _hoisted_14 = {
  class: "table",
  width: "600px"
}
const _hoisted_15 = { width: "80" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "item item1 position-relative" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "item item2 position-relative" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "item item3 position-relative" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "item item4 position-relative" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "item item5 position-relative" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "item item6 position-relative" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "row my-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_error_tips = _resolveComponent("error-tips")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString($setup.locale.windows10), 1)
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Breadcrumb, {
                class: "grey-text",
                item_one_title: $setup.locale.windows11_1,
                item_one_active: true,
                loading: $setup.data.loading
              }, null, 8, ["item_one_title", "loading"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString($setup.locale.windows11_1), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("table", _hoisted_14, [
              _createElementVNode("tr", _hoisted_15, [
                _createElementVNode("td", null, _toDisplayString($setup.locale.windows11_2), 1),
                _createElementVNode("td", null, _toDisplayString($setup.locale.windows11_3), 1),
                _createElementVNode("td", null, _toDisplayString($setup.locale.windows11_4), 1),
                _createElementVNode("td", null, _toDisplayString($setup.locale.windows11_5), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, _toDisplayString($setup.locale.windows11_6), 1),
                _createElementVNode("td", null, _toDisplayString($setup.locale.windows11_7), 1),
                _createElementVNode("td", null, _toDisplayString($setup.locale.windows11_8), 1),
                _createElementVNode("td", null, _toDisplayString($setup.locale.windows11_9), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString($setup.locale.windows11_10), 1),
            _createElementVNode("img", {
              class: "img img1",
              src: $setup.data.images[0]
            }, null, 8, _hoisted_18),
            _createElementVNode("div", _hoisted_19, _toDisplayString($setup.locale.windows11_11), 1),
            _createElementVNode("img", {
              class: "img img2",
              src: $setup.data.images[1]
            }, null, 8, _hoisted_20),
            _createElementVNode("div", _hoisted_21, _toDisplayString($setup.locale.windows11_12), 1),
            _createElementVNode("img", {
              class: "img img3",
              src: $setup.data.images[2]
            }, null, 8, _hoisted_22),
            _createElementVNode("div", _hoisted_23, _toDisplayString($setup.locale.windows11_13), 1),
            _createElementVNode("img", {
              class: "img img4",
              src: $setup.data.images[3]
            }, null, 8, _hoisted_24),
            _createElementVNode("div", _hoisted_25, _toDisplayString($setup.locale.windows11_14), 1),
            _createElementVNode("img", {
              class: "img img5",
              src: $setup.data.images[4]
            }, null, 8, _hoisted_26),
            _createElementVNode("div", _hoisted_27, _toDisplayString($setup.locale.windows11_15), 1),
            _createElementVNode("img", {
              class: "img img6",
              src: $setup.data.images[5]
            }, null, 8, _hoisted_28)
          ]),
          _createElementVNode("div", _hoisted_29, _toDisplayString($setup.locale.windows11_16), 1)
        ])
      ])
    ]),
    _createVNode(_component_error_tips, { ref: "errorRef" }, null, 512)
  ], 64))
}